import React from "react";

//import Scss
import "./assets/scss/themes.scss";

//imoprt Route
import Route from "./Routes";

// Import Firebase Configuration file
// import { initFirebaseBackend } from "./helpers/firebase_helper";

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// The axios-mock-adapter fake backend is intentionally not activated: no route
// in this app reads any of the endpoints it mocks, and mounting it pulled the
// whole src/common/data tree plus axios-mock-adapter into the main bundle.

// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_APIKEY,
//   authDomain: process.env.REACT_APP_AUTHDOMAIN,
//   databaseURL: process.env.REACT_APP_DATABASEURL,
//   projectId: process.env.REACT_APP_PROJECTID,
//   storageBucket: process.env.REACT_APP_STORAGEBUCKET,
//   messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
//   appId: process.env.REACT_APP_APPID,
//   measurementId: process.env.REACT_APP_MEASUREMENTID,
// };

// init firebase backend
// initFirebaseBackend(firebaseConfig);

function App() {
  return (
    <React.Fragment>
      <Route />
      <ToastContainer autoClose={2000} limit={1} />
    </React.Fragment>
  );
}

export default App;
